import { hasCapability, type User } from "../base";

export const conversationClose = {
  update: (user: User) => hasCapability(user, "conversationClose.update"),
};
